import { css } from 'lit';
import { fsDesignToken } from '../../../core/style-util.js';

export const style = css`
  .card.container {
    border-radius: 4px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    height: 100%;
    padding: 16px;

    &.selected {
      border: 1px solid #d4d4d4;
      box-shadow: none;
    }

    .ineligible-reason {
      font-size: 0.875em;
      margin: 0 0.5em;
      text-align: center;
    }
  }

  .flex {
    display: flex;
    flex-direction: row;
  }

  .vehicle-info {
    flex-grow: 1;
    margin-left: ${fsDesignToken('fsSizeSpacingMedium1')};
  }

  .card-button {
    margin-top: 1em;
    width: 100%;
  }

  .helper-text {
    margin-top: 0.5em;
  }

  .vehicle-card__ineligible-reason {
    color: #cc2427;
    display: block;
    font-size: 12px;
    margin-bottom: 10px;
    margin-top: 8px;
    padding-left: 15px;
  }

  p {
    text-align: center;
  }

  ul {
    list-style-type: none;
    padding-left: 0;
    text-align: center;

    @include mq(tablet) {
      padding-left: 1em;
      text-align: left;
    }

    li {
      font: 400 0.875em $ods-font-base__family;

      &.list-title {
        font: 700 1.25em $ods-font-base__family;
      }

      &:not(.list-title) {
        text-transform: uppercase;
      }
    }
  }

  .card-info {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-bottom: 12px;

    &.grey {
      color: #757575;
    }
  }

  .vehicle-card__right {
    line-height: 24px;
    margin-left: 2px;
  }

  .vehicle-card__year-make-model {
    color: ${fsDesignToken('fsTextColorPrimary')};
    font-size: ${fsDesignToken('fsFontSizeMedium1')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    line-height: ${fsDesignToken('fsFontLineHeightNormal')};
    text-align: left;

    &.grey {
      color: #757575;
    }
  }

  .vehicle-card__vin-label,
  .vehicle-card__plate-state {
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
  }

  .vehicle-card__vin,
  .vehicle-card__plate {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
  }

  .vehicle-card__left {
    display: flex;
    flex-direction: row;
    justify-content: start;
  }

  .vehicle-card__label {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 24px;
    width: 100%;
  }

  .vehicle-card__info {
    font-size: 14px;
    margin-left: 1rem;
    text-align: left;
  }

  .vehicle-image {
    height: 32px;
    width: 32px;

    &.grey {
      color: #757575;
    }

    &.motorcycle {
      height: 20px;
    }
  }

  .vehicle-image__container {
    max-width: 50px;
  }

  .vehicle-card__button-container {
    .vehicle-card__button {
      width: 100%;
    }
  }
`;
